import {useTranslation} from 'react-i18next';

import {Box, TextField, useTheme} from '@mui/material';

import {InfoBanner} from '../../../../../../components/InfoBanner/InfoBanner';
import {getFieldStyle} from '../../../../../../layouts/theme/FieldStyles';


export interface Props {
  certifications: string[];
  workingStyleNotes: string;
  industryExperience: string;
  onCertificationsChange: (values: string[]) => void;
  onWorkingStyleNotesChange: (value: string) => void;
  onIndustryExperienceChange: (value: string) => void;
}

export const WorkforceProfileWizardExtrasStep = ({
  certifications,
  workingStyleNotes,
  industryExperience,
  onCertificationsChange,
  onWorkingStyleNotesChange,
  onIndustryExperienceChange,
}: Props) => {
  const theme = useTheme();
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.sections.extras'});

  const normalizeCertifications = (lines: string[]) => lines.map((line) => line.trim()).filter(Boolean);

  const updateCertifications = (value: string) => {
    onCertificationsChange(value === '' ? [] : value.split('\n'));
  };

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      <TextField
        fullWidth
        multiline
        minRows={2}
        size='small'
        label={t('certifications')}
        value={certifications.join('\n')}
        onChange={(event) => updateCertifications(event.target.value)}
        onBlur={() => onCertificationsChange(normalizeCertifications(certifications))}
        helperText={t('certificationsHint')}
        sx={{...getFieldStyle(theme), mb: 2}}
      />
      <TextField
        fullWidth
        multiline
        minRows={2}
        size='small'
        label={t('workingStyle')}
        value={workingStyleNotes}
        onChange={(event) => onWorkingStyleNotesChange(event.target.value)}
        sx={{...getFieldStyle(theme), mb: 2}}
      />
      <TextField
        fullWidth
        multiline
        minRows={2}
        size='small'
        label={t('industry')}
        value={industryExperience}
        onChange={(event) => onIndustryExperienceChange(event.target.value)}
        sx={getFieldStyle(theme)}
      />
    </Box>
  );
};
